<template>
    <!-- 云广播 -->
    <div class="person_box animate__animated animate__fadeIn">
        <div class="person">
            <div class="search_box">
                <div class="box_line">
                    <div class="line_input">
                        <div class="input_title">广播名称</div>
                        <input type="text" class="input_box" placeholder="请输入广播名称" v-model="searchName" />
                    </div>
                    <div class="line_input">
                        <div class="input_title">音频类型</div>
                        <el-select size="small" v-model="searchType" filterable placeholder="请选择"
                            :popper-append-to-body="false" style="border-radius: 0;">
                            <el-option label="请选择" value></el-option>
                            <el-option label="文本转语音" value="0">文本转语音</el-option>
                            <el-option label="音频文件" value="1">音频文件</el-option>
                            <!-- <el-option label="录音" value="2">录音</el-option> -->
                        </el-select>
                    </div>
                    <div class="line_input">
                        <div class="input_title">状态</div>
                        <el-select size="small" v-model="searchStatus" filterable placeholder="请选择"
                            :popper-append-to-body="false" style="border-radius: 0; vertical-align: bottom">
                            <el-option label="请选择" value></el-option>
                            <el-option label="禁用" value="0">禁用</el-option>
                            <el-option label="启用" value="1">启用</el-option>
                        </el-select>
                    </div>
                    <div class="line_input">
                        <div class="input_title">创建时间</div>
                        <el-date-picker size="small" v-model="searchSignDate" type="datetimerange"
                            value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style="width:392px;border-bottom-left-radius: 0;border-top-left-radius: 0;">
                        </el-date-picker>
                    </div>
                    <div class="search-btn" @click="fnSearch"><span>搜索</span></div>
                    <div class="search-btn" style="width: 120px;" @click="fnOpenAddWin"><span>新增广播</span></div>
                </div>
            </div>
            <div class="cont_list">
                <div class="list_title">
                    <div class="title_item">广播名称</div>
                    <div class="title_item">音频时长</div>
                    <div class="title_item">音频类型</div>
                    <div class="title_item">定时循环</div>
                    <div class="title_item">状态</div>
                    <div class="title_item">下发时间</div>
                    <div class="title_item">创建时间</div>
                    <div class="title_item">操作</div>
                </div>
                <div class="list_boxes">
                    <div class="list_box">
                        <div v-if="cardData">
                            <div class="box_line" v-for="(item, index) in cardData" :key="index">
                                <div class="list_item">{{ item.name }}</div>
                                <div class="list_item">{{ item.audio_duration }}秒</div>
                                <div class="list_item">
                                    <span v-if="item.type == 0">文本转语音</span>
                                    <span v-else-if="item.type == 1">音频文件</span>
                                    <!-- <span v-else>录音</span> -->
                                </div>
                                <div class="list_item">{{ item.timed ? '开启' : '未开启' }}</div>
                                <div class="list_item">
                                    <span v-if="item.status == 1">启用</span>
                                    <span v-else style="color: #F56C6C">禁用</span>
                                </div>
                                <div class="list_item">{{ item.push_at }}</div>
                                <div class="list_item">{{ item.create_at }}</div>
                                <div class="list_item">
                                    <div>
                                        <div class="search-btn" @click="fnOpenEditWin(item)"><span>编辑</span></div>
                                        <div class="search-btn" @click="push = item;pushVisible = true"><span>下发</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="cont_page">
                <el-pagination background class="pagination" :page-sizes="pageSizes" :page-size="pageSize"
                    :current-page="currentPage" layout="total, sizes, prev, pager, next, jumper" :total="pageTotal"
                    @size-change="handleSizeChange" @current-change="handleCurrentChange" />
            </div>

            <!-- 新增、编辑弹窗 -->
            <div class="dialog_editdevice animate__animated animate__fadeIn" v-if="saveVisible">
                <el-dialog :title="saveTitle" :modal="false" :visible.sync="saveVisible" center
                    style="text-align: center">
                    <div class="search_box" style="width:100%;height:400px;margin:auto;">

                        <div class="box_line line_input_dialog">
                            <div class="line_input">
                                <div class="input_title">广播名称</div>
                                <input type="text" class="input_box" placeholder="请输入广播名称" v-model="form.name" />
                            </div>
                        </div>

                        <div class="box_line line_input_dialog">
                            <div class="line_input">
                                <div class="input_title">定时循环</div>

                                <el-select size="small" class="timed-select" v-model="form.timed.type" filterable
                                    :popper-append-to-body="false">
                                    <el-option label="关闭" value></el-option>
                                    <el-option label="每天" value="day"></el-option>
                                    <el-option label="N天" value="day-n"></el-option>
                                    <el-option label="每小时" value="hour"></el-option>
                                    <el-option label="N小时" value="hour-n"></el-option>
                                    <el-option label="N分钟" value="minute-n"></el-option>
                                    <el-option label="每星期" value="week"></el-option>
                                    <el-option label="每月" value="month"></el-option>
                                </el-select>

                                <el-select size="small" class="timed-select" v-model="form.timed.time.w" filterable
                                    :popper-append-to-body="false" v-if="form.timed.type == 'week'">
                                    <el-option label="周一" :value="1"></el-option>
                                    <el-option label="周二" :value="2"></el-option>
                                    <el-option label="周三" :value="3"></el-option>
                                    <el-option label="周四" :value="4"></el-option>
                                    <el-option label="周五" :value="5"></el-option>
                                    <el-option label="周六" :value="6"></el-option>
                                    <el-option label="周日" :value="0"></el-option>
                                </el-select>

                                <el-select size="small" class="timed-select" v-model="form.timed.time.d" filterable
                                    :popper-append-to-body="false" v-if="form.timed.type == 'month'">
                                    <el-option v-for="i in 31" :label="i+'日'" :value="i"></el-option>
                                </el-select>

                                <el-select size="small" class="timed-select" v-model="form.timed.time.d" filterable
                                    :popper-append-to-body="false" v-if="form.timed.type == 'day-n'">
                                    <el-option v-for="i in 31" :label="i+'天'" :value="i"></el-option>
                                </el-select>

                                <el-select size="small" class="timed-select" v-model="form.timed.time.H" filterable
                                    :popper-append-to-body="false"
                                    v-if="form.timed.type && form.timed.type != 'hour' && form.timed.type != 'minute-n'">
                                    <el-option v-for="i in 23" :label="i+'小时'" :value="i"></el-option>
                                </el-select>

                                <el-select size="small" class="timed-select" v-model="form.timed.time.i" filterable
                                    :popper-append-to-body="false" v-if="form.timed.type">
                                    <el-option v-for="i in 59" :label="i+'分钟'" :value="i"></el-option>
                                </el-select>

                                <el-time-picker is-range v-model="form.timed.range_time" range-separator="至"
                                    start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围"
                                    class="timed-select" style="width:230px;" value-format="HH:mm" format="HH:mm"
                                    v-if="form.timed.type == 'hour' ||form.timed.type == 'hour-n' || form.timed.type == 'minute-n'">
                                </el-time-picker>

                            </div>
                        </div>

                        <div class="box_line line_input_dialog">
                            <div class="line_input">
                                <div class="input_title">播放设备</div>
                                <el-select size="small" :disabled="!form.timed.type" v-model="form.timed.deviceSerials"
                                    filterable :popper-append-to-body="false" style="width:480px;" multiple
                                    collapse-tags>
                                    <el-option v-for="item in channel" :label="'通道'+item.channelNo+':'
                                    +item.deviceSerial+'_'+item.name" :value="item.deviceSerial"></el-option>
                                </el-select>
                            </div>
                        </div>

                        <div class="box_line line_input_dialog">
                            <div class="line_input">
                                <div class="input_title">音频类型</div>
                                <el-radio-group v-model="form.type" style="margin-left: 10px;">L
                                    <el-radio :label="0">文本转语音</el-radio>
                                    <el-radio :label="1">音频文件</el-radio>
                                    <!-- <el-radio :label="2">录音</el-radio> -->
                                </el-radio-group>
                            </div>
                        </div>

                        <div class="box_line line_input_dialog" style="height: 117px;">
                            <div class="line_input" style="height: 117px;">
                                <div class="input_title" style="height: 117px;">音频文本</div>
                                <el-input :disabled="form.type != 0" type="textarea" :rows="5"
                                    placeholder="请输入文字转语音文本,最多300字!" v-model="form.audio_text" resize="none"
                                    @input="fnChangeAudioText" />
                            </div>
                        </div>

                        <div class="box_line line_input_dialog">
                            <div class="line_input">
                                <div class="input_title">文字转语音性别</div>
                                <el-radio-group v-model="form.audio_text_sex" :disabled="form.type != 0"
                                    style="margin-left: 10px;">
                                    <el-radio :label="1">男</el-radio>
                                    <el-radio :label="0">女</el-radio>
                                </el-radio-group>
                            </div>
                        </div>

                        <div class="box_line line_input_dialog">
                            <div class="line_input">
                                <div class="input_title">音频文件</div>
                                <span class="fileinput-button">
                                    <span v-if="!audio_file">{{form.type == 0 ? "文本转语音无需选择" : "选择音频文件"}}</span>
                                    <span v-else>{{form.type == 0 ? "已上传" : (form.id ? "重新上传" :  "重新选择")}}</span>
                                    <input v-if="form.type != 0" type="file" name="audio_file" accept="audio/mp3"
                                        @change="changeFile">
                                </span>
                                <audio v-if="audio_file" controls="controls" style="width: 2200px; height: 30px;"
                                    :src="audio_file"></audio>
                            </div>
                        </div>

                        <div class="box_line line_input_dialog">
                            <div class="line_input">
                                <div class="input_title">状态</div>
                                <el-radio-group v-model="form.status" style="margin-left: 10px;">
                                    <el-radio :label="1">启用</el-radio>
                                    <el-radio :label="0">禁用</el-radio>
                                </el-radio-group>
                            </div>
                        </div>

                    </div>
                    <div slot="footer" class="dialog-footer" style="margin-top: 20px;">
                        <div class="btn_line">
                            <div class="search-btn red" @click="saveVisible = false"><span>取消</span></div>
                            <div class="search-btn" @click="fnSave"><span>保存</span></div>
                        </div>
                    </div>
                </el-dialog>
            </div>

            <div class="dialog_editdevice animate__animated animate__fadeIn" v-if="pushVisible">
                <el-dialog :custom-class="'animate__animated animate__fadeIn'" :modal="false" title="选择广播设备" top="20vh"
                    center :visible.sync="pushVisible">
                    <div class="cont_list" style="width: 550px;height: 380px;color: #fff;">
                        <div class="list_title" style="width: 550px;">
                            <div class="title_item" style="width: 60px;">
                                <div class="select" @click="fnSelectAllChannel()"
                                    :class="selectAllChannel ? 'active' : ''"></div>
                            </div>
                            <div class="title_item" style="width: 100px;">通道号</div>
                            <div class="title_item" style="width: 160px;">设备号</div>
                            <div class="title_item" style="width: 160px;">通道名</div>
                        </div>
                        <div class="list_boxes" style="width: 550px;height: 330px;">
                            <div class="list_box" style="width: 550px;height: 330px;">
                                <div class="box_line" v-for="(item, index) in channel" :key="index"
                                    @click="fnHandleCheckedChannelChange(index, item)">
                                    <div class="list_item" style="width: 60px;">
                                        <div class="select" :class="item.selected ? 'active' : ''"></div>
                                    </div>
                                    <div class="list_item" style="width: 100px;">{{ item.channelNo }}</div>
                                    <div class="list_item" style="width: 160px;">{{ item.deviceSerial }}</div>
                                    <div class="list_item" style="width: 160px;">{{ item.name }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div slot="footer" class="dialog-footer" align="center">
                        <div class="btn_line">
                            <div class="search-btn red" @click="pushVisible = false"><span>取消</span></div>
                            <div class="search-btn" @click="fnPush"><span>下发</span></div>
                        </div>
                    </div>
                </el-dialog>
            </div>

        </div>
    </div>
</template>

<script>
    import request from '@/utils/request';
    import APP from '@/utils/base';
    import {
        getUserInfo
    } from '@/utils/auth';

    export default {
        data() {
            return {
                saveTitle: '新增广播音频',
                pageSize: APP.PAGE.LIMIT,
                pageSizes: APP.PAGE.SIZE_OPTION,
                currentPage: APP.PAGE.SKIP_PAGE,
                pageTotal: 0,
                saveVisible: false,
                pushVisible: false,
                searchName: '',
                searchType: '',
                searchStatus: '',
                searchSignDate: '',
                cardData: [],
                serchtime: '',
                form: {
                    id: '', // 云广播id
                    name: '', // 广播名称
                    timed: {}, // 定时循环
                    type: 0, // 语音类型
                    audio_text: '', // 音频文本
                    audio_text_sex: 1, // 文字转语音性别
                    audio_file: '', // 音频文件
                    status: 1, // 状态
                },
                timed: {
                    type: "", // 循环类型（day：每天，day-n：N天，hour：每小时，hour-n：N小时，minute-n：N分钟，week：每星期，month：每月）(必填)
                    time: {
                        w: 1,
                        d: 1,
                        H: 1,
                        i: 30
                    }, // 指定时间（day：小时:分钟，day-n：小时:分钟，hour：分钟，hour-n：分钟，week：星期:小时:分钟，month：日:小时:分钟）（type为minute-n非必填，其余必填）
                    range_time: ['09:00', '20:00'], // 执行时间区间（type为day-n、hour-n、minute-n必填）
                    deviceSerials: "" // 设备编号（多台设备,分割，必填）
                },
                channel: [],
                audio_file: '',
                selectChannel: [], // 选中的设备
                selectAllChannel: false,
                push: {}
            };
        },
        created() {
            this.fnGetData({
                page: this.currentPage,
                size: this.pageSize
            });
        },
        methods: {
            fnChangeAudioText() {
                this.audio_file = ''
            },
            // 更改分页内容
            handleSizeChange(val) {
                this.pageSize = val;
                this.fnSearch(false);
            },
            // 翻页
            handleCurrentChange(val) {
                this.currentPage = val;
                this.fnSearch(false);
            },
            changeFile(e) {
                this.form.audio_file = e.target.files[0]
                this.audio_file = URL.createObjectURL(this.form.audio_file)
            },
            //获取设备数据
            fnGetData(_obj) {
                request({
                        url: '/audio/get',
                        method: 'GET',
                        params: _obj
                    })
                    .then(res => {
                        this.cardData = res.data.query;
                        this.pageTotal = res.data.count;
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });

                request({
                        url: '/zgj-monitor/getMonitorList',
                        method: 'GET',
                    })
                    .then(res => {
                        this.channel = []
                        res.data.forEach(val => {
                            let channel = JSON.parse(val.channel)
                            channel.forEach(channelVal => {
                                if (channelVal.intercom) {
                                    this.channel.push({
                                        name: channelVal.name ? channelVal.name : '未命名',
                                        channelNo: channelVal.channelNo,
                                        deviceSerial: channelVal.intercom.deviceSerial,
                                        selected: false
                                    })
                                }
                            })
                        })
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });
            },
            // 搜索
            fnSearch(_isReset = true) {
                if (this.searchSignDate) {
                    this.serchtime = this.searchSignDate[0] + ',' + this.searchSignDate[1];
                } else {
                    this.serchtime = '';
                }
                this.currentPage = _isReset ? APP.PAGE.SKIP_PAGE : this.currentPage;
                this.fnGetData({
                        page: this.currentPage,
                        size: this.pageSize,
                        name: this.searchName,
                        type: this.searchType,
                        status: this.searchStatus,
                        create_at: this.serchtime
                    },
                    res => {
                        this.cardData = res.query;
                        this.pageTotal = res.count;
                    }
                );
            },
            // 打开新增设备窗口
            fnOpenAddWin() {
                this.saveTitle = '新增广播音频'
                this.form.id = '';
                this.form.name = '';
                this.form.timed = this.timed;
                this.form.type = 0;
                this.form.audio_text = '';
                this.form.audio_text_sex = 1;
                this.form.audio_file = '';
                this.audio_file = '';
                this.form.status = 1;
                this.saveVisible = true;
            },
            // 打开编辑设备窗口
            fnOpenEditWin(_data) {
                this.saveTitle = '编辑广播音频'
                this.form.id = _data.id;
                this.form.name = _data.name;
                this.form.timed = _data.timed ? JSON.parse(_data.timed) : this.timed;
                this.form.type = _data.type;
                this.form.audio_text = _data.audio_text;
                this.form.audio_text_sex = _data.audio_text_sex;
                this.form.audio_file = _data.audio_file;
                this.audio_file = _data.audio_file;
                this.form.status = _data.status;
                this.saveVisible = true;
            },
            // 编辑设备
            fnSave() {

                if (this.form.timed.type && !this.form.timed.deviceSerials.length) {
                    this.$message.warning('请选择需要播放的设备.');
                    return
                }

                let formData = new FormData();
                for (let i in this.form) {
                    if (i == 'timed') {
                        formData.append(i, JSON.stringify(this.form[i]));
                    } else {
                        formData.append(i, this.form[i]);
                    }
                }

                request({
                        url: '/audio/save',
                        method: 'POST',
                        data: formData
                    })
                    .then(res => {
                        this.$message.success(res.data);
                        this.saveVisible = false;
                        this.fnSearch();
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });
            },
            fnPush() {
                if (!this.selectChannel.length) {
                    this.$message.warning('请选择需要下发的设备.');
                    return
                }

                let deviceSerials = []

                this.selectChannel.forEach(d => {
                    deviceSerials.push(d.deviceSerial)
                })

                request({
                        url: '/audio/push',
                        method: 'POST',
                        data: {
                            deviceSerials: deviceSerials,
                            audio_file: this.push.audio_file
                        }
                    })
                    .then(res => {
                        this.$message.success(res.data);
                        this.pushVisible = false;
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });
            },
            fnSelectAllChannel() {
                let _arr = [];
                let selected = this.selectChannel.length != this.channel.length
                for (var i in this.channel) {
                    _arr.push(this.channel[i]);
                    this.channel[i].selected = selected;
                }
                this.selectAllChannel = selected;
                this.selectChannel = selected ? _arr : [];
            },
            fnHandleCheckedChannelChange(_index, _item) {
                for (let i = 0; i < this.channel.length; i++) {
                    if (i == _index) {
                        this.channel[i].selected = !this.channel[i].selected;
                    }
                }
                let _arr = [];
                for (let j = 0; j < this.channel.length; j++) {
                    if (this.channel[j].selected) {
                        _arr.push(this.channel[j]);
                    }
                }
                if (_arr.length == this.channel.length) {
                    this.selectAllChannel = true;
                } else {
                    this.selectAllChannel = false;
                }
                this.selectChannel = _arr;
            }
        }
    };
</script>

<style scoped lang="scss" type="text/scss">
    @import '~@/styles/mixin.scss';
.person_box {
	width: 1920px;
	height: 858px;
	position: relative;
	overflow: hidden;
	.person {
		position: absolute;
		left: 0;
		right: -20px;
		top: 0;
		bottom: 0;
		overflow-x: hidden;
		overflow-y: auto;
	}
}
.search_box {
	width: 1880px;
	margin-top: 24px;
	margin-left: 20px;
	@include flex-box(space-between, center, column);
	.box_line {
		width: 1880px;
		height: 32px;
		@include flex-box(flex-start, center);
		.line_input {
			min-width: 280px;
			height: 30px;
			margin-right: 10px;
			border-top-right-radius: 1px;
			border-bottom-right-radius: 1px;
			background-color: rgba(49, 88, 128, 0.4);
			@include flex-box(flex-start, center);
			.input_title {
				padding: 0 5px;
				min-width: 69px;
				height: 30px;
				font-size: 14px;
				color: #9bf9fc;
				border-radius: 2px;
				background-color: rgba(155, 249, 252, 0.1);
				@include flex-box(center, center);
			}
			.input_box {
				width: 211px;
				height: 30px;
				line-height: 30px;
				padding-left: 15px;
				color: rgba(77, 180, 244, 0.7);
				font-size: 12px;
				border-radius: 2px;
				outline: none;
				background: transparent;
				border: none;
				&::-webkit-input-placeholder {
					color: rgba(77, 180, 244, 0.7);
				}
				&::-moz-placeholder {
					/* Mozilla Firefox 19+ */
					color: rgba(77, 180, 244, 0.7);
				}
				&:-moz-placeholder {
					/* Mozilla Firefox 4 to 18 */
					color: rgba(77, 180, 244, 0.7);
				}
				&:-ms-input-placeholder {
					/* Internet Explorer 10-11 */
					color: rgba(77, 180, 244, 0.7);
				}
			}
			.select_box {
				width: 211px;
				height: 30px;
				border-radius: 2px;
			}
		}
    }
    .line_input_dialog{

        .line_input{
            margin:auto;
            width: 550px;
            .input_box{
                width: 480px;
            }
             >>> .el-radio {
               color: rgba(255, 255, 255, 0.8);
             }

            .fileinput-button {
                width: 400px;
                margin-left: 10px;
                color: rgba(255, 255, 255, 0.8);
                position: relative;
                display: inline-block;
                overflow: hidden;
                cursor: pointer;
            }
            .fileinput-button input{
                position: absolute;
                left: 0px;
                top: 0px;
                opacity: 0;
                -ms-filter: 'alpha(opacity=0)';
                cursor: pointer;
            }
            .timed-select{
                width: 85px;
                background-color: rgba(255,255,255,.8);
                margin-right: 3px;
                border-radius: 5px;
            }

            >>> .el-input__inner{
                color:rgba(0, 0, 0, 0.8);
            }

            >>> .el-input__icon,>>> .el-range-separator{
                line-height: 25px;
                color: #409eff;
            }
        }

    }
}
.cont_list {
	margin-top: 29px;
	margin-left: 28px;
	width: 1864px;
	height: 625px;
	border-radius: 10px;
	background-color: rgba(29, 68, 149, 0.1);
	.list_title {
		width: 1864px;
		height: 48px;
		background: url(../../../assets/img/per_list_bg.png) no-repeat;
		background-size: 100% 100%;
		@include flex-box(flex-start, center);
		.title_item {
			height: 48px;
			@include flex-box(center, center);
			&:nth-child(1) {
                width: 242px;
                margin: 0 4px 0 40px;
			}
			&:nth-child(2) {
				width: 196px;
                margin-right: 4px;
			}
			&:nth-child(3) {
				width: 196px;
				margin-right: 4px;
			}
			&:nth-child(4) {
				width: 196px;
				margin-right: 4px;
			}
			&:nth-child(5) {
				width: 196px;
				margin-right: 4px;
			}
			&:nth-child(6) {
				width: 242px;
                margin-right: 4px;
			}
			&:nth-child(7) {
				width: 242px;
				margin-right: 4px;
			}
			&:nth-child(8) {
				width: 242px;
			}

            .select {
              width: 20px;
              height: 20px;
              border: 1px solid #65a6dd;
              border-radius: 2px;
              cursor: pointer;
              @include prefixCss3(transition, border-color 0.2s);
              &:hover {
                border-color: #409eff;
              }
              &.active {
                background-color: #409eff;
                border-color: #409eff;
                &::after {
                  content: '';
                  display: block;
                  width: 100%;
                  height: 100%;
                  @include set-bg-img('../../../assets/images/icon-yes.png');
                }
              }
            }
		}
	}
	.list_boxes {
		width: 1864px;
		height: 513px;
		position: relative;
		overflow: hidden;
		.list_box {
			position: absolute;
			left: 0;
			right: -25px;
			top: 0;
			bottom: 0;
			overflow-x: hidden;
			overflow-y: auto;
			.box_line {
				width: 1784px;
				height: 70px;
				margin: 7px 0 0 40px;
				font-size: 16px;
				color: #ffffff;
				border-bottom: 1px dashed #1d4495;
				@include flex-box(flex-start, center);
				&:hover{
					background-color: rgba(49, 88, 128, 0.4);
				}
				.list_item {
					height: 70px;
					text-align: center;
					@include flex-box(center, center);
					&:nth-child(1) {
                        width: 242px;
						margin-right: 4px;
					}
					&:nth-child(2) {
						width: 196px;
					    margin-right: 4px;
					}
					&:nth-child(3) {
						width: 196px;
						margin-right: 4px;
					}
					&:nth-child(4) {
						width: 196px;
						margin-right: 4px;
					}
					&:nth-child(5) {
						width: 196px;
						margin-right: 4px;
					}
					&:nth-child(6) {
						width: 242px;
					    margin-right: 4px;
					}
					&:nth-child(7) {
						width: 242px;
						margin-right: 4px;
						cursor: pointer;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
					}
					&:nth-child(8) {
						width: 242px;
					}
					img {
						width: 40px;
						height: 40px;
						border-radius: 50%;
					}
					div {
						@include flex-box(center, center);
					}

                    .select {
                      width: 20px;
                      height: 20px;
                      border: 1px solid #65a6dd;
                      border-radius: 2px;
                      cursor: pointer;
                      @include prefixCss3(transition, border-color 0.2s);
                      &:hover {
                        border-color: #409eff;
                      }
                      &.active {
                        background-color: #409eff;
                        border-color: #409eff;
                        &::after {
                          content: '';
                          display: block;
                          width: 100%;
                          height: 100%;
                          @include set-bg-img('../../../assets/images/icon-yes.png');
                        }
                      }
                    }
				}
			}
		}
	}
}
.box_line {
	>>> .el-input__inner {
		width: 211px;
		height: 30px;
		border-radius: 2px;
		border: none;
		color: rgba(77, 180, 244, 0.7);
		background: transparent;
		&::-webkit-input-placeholder {
			color: rgba(77, 180, 244, 0.7);
		}
		&::-moz-placeholder {
			/* Mozilla Firefox 19+ */
			color: rgba(77, 180, 244, 0.7);
		}
		&:-moz-placeholder {
			/* Mozilla Firefox 4 to 18 */
			color: rgba(77, 180, 244, 0.7);
		}
		&:-ms-input-placeholder {
			/* Internet Explorer 10-11 */
			color: rgba(77, 180, 244, 0.7);
		}
	}
	>>>.el-select__caret {
		color: rgba(77, 180, 244, 0.7);
	}
	>>> .el-select-dropdown {
		background-color: rgba(9, 17, 32, 1);
		border: 1px solid rgba(77, 180, 244, 1);
	}
	>>> .popper__arrow {
		border-bottom-color: rgba(77, 180, 244, 1) !important;
	}
	>>> .el-select-dropdown__item {
		color: rgba(77, 180, 244, 0.7);
	}
	>>> .el-select-dropdown__item:hover {
		color: #409eff;
	}
	>>> .el-select-dropdown__item.hover {
		color: #409eff;
	}
	>>> .el-input__icon {
		color: rgba(77, 180, 244, 0.7);
	}
	>>> .el-range-input {
		background: transparent;
		&::-webkit-input-placeholder {
			color: rgba(77, 180, 244, 0.7);
		}
		&::-moz-placeholder {
			/* Mozilla Firefox 19+ */
			color: rgba(77, 180, 244, 0.7);
		}
		&:-moz-placeholder {
			/* Mozilla Firefox 4 to 18 */
			color: rgba(77, 180, 244, 0.7);
		}
		&:-ms-input-placeholder {
			/* Internet Explorer 10-11 */
			color: rgba(77, 180, 244, 0.7);
		}
	}
	>>> .el-range-separator {
		color: rgba(77, 180, 244, 0.7);
	}
}
.dialog_editdevice {
	.btn_line {
		@include flex-box(center, center);
	}
	>>> .el-dialog {
		width: 660px;
		height: 600px;
		margin-top: 20vh !important;
		background-color: rgba(9, 17, 32, 1);
		border: 1px solid rgba(58, 116, 221, 1);
	}
	>>> .el-form-item__label {
		color: #4db4f4;
	}
	>>> .el-dialog__title {
		color: #4db4f4;
	}
	>>> .el-dialog__close {
		color: #4db4f4;
	}
}
</style>



// WEBPACK FOOTER //
// src/views/Broadcast/broadcastDefault/index.vue